import React, { FC, useEffect, useState } from "react";
import facebookSvg from "images/Facebook.svg";
import twitterSvg from "images/Twitter.svg";
import googleSvg from "images/Google.svg";
import { Helmet } from "react-helmet-async";
import Input from "shared/Input/Input";
import { useLocation, useNavigate } from "react-router-dom";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { auth } from "../../config/firebase";
import { useMyContext } from "context/footerContext";
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  MenuItem,
  Select,
  Stepper,
  Typography,
  Input as MUIInput,
  Link,
  Step,
  StepLabel,
} from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

import { StyledDropzone } from "./StyledDropZone";

const LinkStyles = {
  color: "blue",
  textDecoration: "underline",
};

export interface PageLoginProps {
  className?: string;
}

const steps = [
  "Personal information",
  "Professional infomration",
  "Upload photos",
];

const PageFitStuffRegistration: FC<PageLoginProps> = ({ className = "" }) => {
  const [activeStep, setActiveStep] = React.useState(0);
  const [skipped, setSkipped] = React.useState(new Set<number>());
  const { setValidFooter } = useMyContext();

  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loadingButton, setLoadingButton] = useState(false);
  const location = useLocation();

  const onSubmit = async (e: any) => {
    e.preventDefault();
    setLoadingButton(true);
    await createUserWithEmailAndPassword(auth, email, password)
      .then((userCredential) => {
        // Signed in
        const user = userCredential.user;
        console.log(user);
        navigate("/login");
        setLoadingButton(false);
      })
      .catch((error) => {
        const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorCode, errorMessage);
        setLoadingButton(false);
      });
  };

  useEffect(() => {
    setValidFooter(location.pathname);

    return () => {
      setValidFooter("");
    };
  }, []);

  //   const isStepOptional = (step: number) => {
  //     return step === 1;
  //   };

  const isStepSkipped = (step: number) => {
    return skipped.has(step);
  };

  const handleNext = () => {
    let newSkipped = skipped;
    if (isStepSkipped(activeStep)) {
      newSkipped = new Set(newSkipped.values());
      newSkipped.delete(activeStep);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped(newSkipped);
  };

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const handleSkip = () => {
    // if (!isStepOptional(activeStep)) {
    //   // You probably want to guard against something like this,
    //   // it should never occur unless someone's actively trying to break something.
    //   throw new Error("You can't skip a step that isn't optional.");
    // }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
    setSkipped((prevSkipped) => {
      const newSkipped = new Set(prevSkipped.values());
      newSkipped.add(activeStep);
      return newSkipped;
    });
  };

  const handleReset = () => {
    setActiveStep(0);
  };

  return (
    <div className={`nc-PageLogin ${className}`} data-nc-id="PageLogin">
      <Helmet>
        <title>Login</title>
      </Helmet>
      <div className="container mb-24 lg:mb-32 mx-auto">
        <h3 className="my-8 text-3xl md:text-5xl font-semibold text-center">
          Sign up
        </h3>
        <Stepper activeStep={activeStep} sx={{ marginTop: "50px" }}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
            } = {};
            if (skipped.has(index)) {
              stepProps.completed = false;
            }
            return (
              <Step
                key={label}
                {...stepProps}
                sx={{
                  "& .MuiStepLabel-root .Mui-completed": {
                    color: "#4BC165",
                  },
                  "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel":
                    {
                      color: "grey.500",
                    },
                  "& .MuiStepLabel-root .Mui-active": {
                    color: "#4BC165",
                  },
                  "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel":
                    {
                      color: "common.white",
                    },
                  "& .MuiStepLabel-root .Mui-active .MuiStepIcon-text": {
                    fill: "white",
                  },
                }}
              >
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
        {activeStep === steps.length ? (
          <React.Fragment>
            <Typography sx={{ mt: 2, mb: 1 }}>
              All steps completed - you&apos;re finished
            </Typography>
            <Box sx={{ display: "flex", flexDirection: "row", pt: 2 }}>
              <Box sx={{ flex: "1 1 auto" }} />
              <Button onClick={() => setActiveStep(0)}>Reset</Button>
            </Box>
          </React.Fragment>
        ) : (
          <React.Fragment>
            {activeStep === 0 ? (
              <div className="flex justify-center shadow-[0_0_40px_-15px_rgba(0,0,0,0.3)] rounded-3xl w-full sm:w-[90%] md:w-[80%] lg:w-[670px] mx-auto px-4 sm:px-6 lg:px-8 mt-8 sm:mt-16 md:mt-24 pb-[90px] relative">
                <Button
                  variant="contained"
                  sx={{
                    width: "30px",
                    minWidth: "30px",
                    height: "30px",
                    borderRadius: "50%",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#4BC165",
                    ":hover": {
                      bgcolor: "#74f290",
                    },
                  }}
                  disabled={activeStep === 0}
                  onClick={handleBack}
                >
                  <ArrowBackIosNewIcon sx={{ width: 15, height: 15 }} />
                </Button>
                <div className="w-full mt-[40px]">
                  <div className="mx-auto space-y-6 ">
                    {/* FORM */}
                    <form
                      className="grid grid-cols-1 gap-6 mt-8"
                      onSubmit={onSubmit}
                    >
                      <div className="grid grid-cols-2 gap-5">
                        <label className="block mb-2">
                          <span className="text-neutral-800 dark:text-neutral-200">
                            Firstname
                          </span>
                          <Input
                            type="text"
                            placeholder="Firstname"
                            className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          />
                        </label>

                        <label className="block mb-2">
                          <span className="text-neutral-800 dark:text-neutral-200">
                            Lastname
                          </span>
                          <Input
                            type="text"
                            placeholder="Lastname"
                            className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          />
                        </label>
                      </div>

                      <label className="block mb-2">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Date of birth
                        </span>
                        <DatePicker
                          value={null}
                          sx={{
                            width: "100%",
                            borderRadius: "12px",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#e5e7eb",
                                borderRadius: "12px",
                              },
                              "& input": {
                                padding: "15px 15px",
                              },
                            },
                          }}
                        />
                      </label>

                      <label className="block mb-2">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Phone number
                        </span>
                        <Input
                          type="text"
                          placeholder="+995"
                          className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          required
                        />
                      </label>

                      <label className="block mb-2">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Email
                        </span>
                        <Input
                          type="email"
                          placeholder="example@example.com"
                          className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          required
                        />
                      </label>

                      <label className="block mb-2">
                        <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                          Password
                        </span>
                        <Input
                          type="password"
                          className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </label>

                      <label className="block mb-2">
                        <span className="flex justify-between items-center text-neutral-800 dark:text-neutral-200">
                          Repeat password
                        </span>
                        <Input
                          type="password"
                          className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                        />
                      </label>
                    </form>

                    <Button
                      variant="contained"
                      sx={{
                        display: "block",
                        margin: "0 auto",
                        backgroundColor: "#4BC165",
                        ":hover": {
                          bgcolor: "#74f290",
                        },
                      }}
                      onClick={
                        activeStep === steps.length - 1 ? onSubmit : handleNext
                      }
                    >
                      {activeStep === steps.length - 1 ? "Register" : "Next"}
                    </Button>
                  </div>
                </div>
              </div>
            ) : activeStep === 1 ? (
              <div className="flex justify-center shadow-[0_0_40px_-15px_rgba(0,0,0,0.3)] rounded-3xl w-full sm:w-[90%] md:w-[80%] lg:w-[670px] mx-auto px-4 sm:px-6 lg:px-8 mt-8 sm:mt-16 md:mt-24 pb-[90px] relative">
                <Button
                  variant="contained"
                  sx={{
                    width: "30px",
                    minWidth: "30px",
                    height: "30px",
                    borderRadius: "100%",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#4BC165",
                    ":hover": {
                      bgcolor: "#74f290",
                    },
                  }}
                  onClick={handleBack}
                >
                  <ArrowBackIosNewIcon sx={{ width: 15, height: 15 }} />
                </Button>
                <div className="w-full mt-[40px]">
                  <div className="mx-auto space-y-6 ">
                    {/* FORM */}
                    <form
                      className="grid grid-cols-1 gap-6 mt-8"
                      onSubmit={onSubmit}
                    >
                      <label className="block mb-2">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Profession
                        </span>
                        <Select
                          labelId="demo-simple-select-label"
                          id="demo-simple-select"
                          label="Profession"
                          fullWidth
                          sx={{
                            width: "100%",
                            borderRadius: "12px",
                            "& .MuiOutlinedInput-root": {
                              "& fieldset": {
                                borderColor: "#e5e7eb",
                                borderRadius: "12px",
                              },
                              "&.MuiSelect-select": {
                                padding: "15px 14 !important",
                              },
                              "& input": {
                                padding: "15px 0",
                              },
                            },
                          }}
                        >
                          <MenuItem value={10}>Trainer</MenuItem>
                        </Select>
                      </label>

                      <label className="block mb-2">
                        <span className="text-neutral-800 dark:text-neutral-200">
                          Years of experience
                        </span>
                        <Input
                          type="text"
                          className="mt-1 h-[50px] md:h-[70px] rounded-xl"
                          required
                        />
                      </label>
                    </form>

                    <Button
                      variant="contained"
                      sx={{
                        display: "block",
                        margin: "0 auto",
                        backgroundColor: "#4BC165",
                        ":hover": {
                          bgcolor: "#74f290",
                        },
                      }}
                      onClick={
                        activeStep === steps.length - 1 ? onSubmit : handleNext
                      }
                    >
                      {activeStep === steps.length - 1 ? "Register" : "Next"}
                    </Button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="flex justify-center shadow-[0_0_40px_-15px_rgba(0,0,0,0.3)] rounded-3xl w-full sm:w-[90%] md:w-[80%] lg:w-[670px] mx-auto px-4 sm:px-6 lg:px-8 mt-8 sm:mt-16 md:mt-24 pb-[90px] relative">
                <Button
                  variant="contained"
                  sx={{
                    width: "30px",
                    minWidth: "30px",
                    height: "30px",
                    borderRadius: "100%",
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    backgroundColor: "#4BC165",
                    ":hover": {
                      bgcolor: "#74f290",
                    },
                  }}
                  onClick={handleBack}
                >
                  <ArrowBackIosNewIcon sx={{ width: 15, height: 15 }} />
                </Button>
                <div className="w-full mt-[40px]">
                  <div className="mx-auto mt-8">
                    {/* Profile image upload */}
                    <div className="w-full mx-auto bg-white mb-8 rounded-md">
                      <h2 className="text-2xl font-bold mb-4">
                        Profile Image Upload
                      </h2>
                      <StyledDropzone
                        isMultiple={false}
                        previewTxt="Drag 'n' drop your profile image here, or click to select files"
                      />
                    </div>

                    {/* Personal ID Card upload */}
                    <div className="w-full mx-auto bg-white mb-8 rounded-md">
                      <h2 className="text-2xl font-bold mb-4">
                        Personal ID Upload
                      </h2>
                      <StyledDropzone
                        isMultiple
                        previewTxt="Drag 'n' drop your personal id card images here, or click to select files"
                      />
                    </div>

                    {/* Certificates image upload */}
                    <div className="w-full mx-auto bg-white mb-8  rounded-md">
                      <h2 className="text-2xl font-bold mb-4">
                        Certificates Upload
                      </h2>
                      <StyledDropzone
                        isMultiple
                        previewTxt="Drag 'n' drop your certificate images here, or click to select files"
                      />
                    </div>

                    {/* Personal images upload */}
                    <div className="w-full mx-auto bg-white mb-8  rounded-md">
                      <h2 className="text-2xl font-bold mb-4">
                        Personal Images Upload
                      </h2>
                      <StyledDropzone
                        isMultiple
                        previewTxt="Drag 'n' drop your personal images here, or click to select files"
                      />
                    </div>

                    <FormControlLabel
                      control={<Checkbox />}
                      label={
                        <Box>
                          Accept all{" "}
                          <Link target="_blank" href="/terms-conditions">
                            terms and conditions
                          </Link>
                        </Box>
                      }
                    />

                    <Button
                      variant="contained"
                      sx={{
                        display: "block",
                        margin: "0 auto",
                        backgroundColor: "#4BC165",
                        ":hover": {
                          bgcolor: "#74f290",
                        },
                      }}
                      onClick={
                        activeStep === steps.length - 1 ? onSubmit : handleNext
                      }
                    >
                      {activeStep === steps.length - 1 ? "Register" : "Next"}
                    </Button>
                  </div>
                </div>
              </div>
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
};

export default PageFitStuffRegistration;
